<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="headers"
      :items="categories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Categorias de Quartos</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            rounded
            class="mb-2"
            @click="newItem()"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
            Nova Categoria
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                v-bind="attrs"
                @click="editItem(item)"
                v-on="on"
              >
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="teal"
                class="mr-2"
                v-bind="attrs"
                @click="openIcal(item)"
                v-on="on"
              >
                {{ icons.mdiCalendarSync }}
              </v-icon>
            </template>
            <span>Sincronização iCal</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                v-bind="attrs"
                @click="deleteItem(item)"
                v-on="on"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <!-- DIALOG CRIAR/EDITAR CATEGORIA -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <div class="title_body">
          <span class="text_title">{{ formTitle }}</span>
          <span class="btn_close">
            <v-btn
              icon
              small
              @click="close"
            ><v-icon dark>{{ icons.mdiClose }}</v-icon></v-btn>
          </span>
        </div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.description"
                  outlined
                  label="Categoria"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Fechar
          </v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG iCAL -->
    <v-dialog
      v-model="dialogIcal"
      max-width="700px"
      scrollable
    >
      <v-card>
        <div class="title_body">
          <span class="text_title">
            <v-icon
              color="teal"
              class="mr-1"
            >{{ icons.mdiCalendarSync }}</v-icon>
            iCal — {{ icalItem.description }}
          </span>
          <span class="btn_close">
            <v-btn
              icon
              small
              @click="closeIcal"
            ><v-icon dark>{{ icons.mdiClose }}</v-icon></v-btn>
          </span>
        </div>

        <v-card-text>
          <v-container>
            <!-- Export -->
            <div class="text-subtitle-2 font-weight-bold mb-1 mt-2">
              Export — Hotel → Canais
            </div>
            <div class="text-caption grey--text mb-2">
              Cole esta URL no painel do canal (Booking Extranet, Airbnb, Google Calendar etc.)
            </div>
            <v-text-field
              :value="icalExportUrl"
              outlined
              dense
              readonly
              hide-details
              class="mb-4"
              :append-icon="icons.mdiContentCopy"
              @click:append="copyExportUrl"
            >
              <template v-slot:append-outer>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      :loading="loadingRegenToken"
                      v-bind="attrs"
                      @click="confirmRegenToken"
                      v-on="on"
                    >
                      <v-icon small>
                        {{ icons.mdiRefresh }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Regenerar token (invalida URL atual)</span>
                </v-tooltip>
              </template>
            </v-text-field>

            <v-divider class="mb-4" />

            <!-- Import feeds -->
            <div class="d-flex align-center justify-space-between mb-2">
              <div>
                <div class="text-subtitle-2 font-weight-bold">
                  Import — Canais → Hotel
                </div>
                <div class="text-caption grey--text">
                  Feeds externos criam reservas com status "Canal Externo"
                </div>
              </div>
              <v-btn
                small
                color="teal"
                dark
                @click="dialogAddFeed = true"
              >
                <v-icon
                  small
                  class="mr-1"
                >
                  {{ icons.mdiPlus }}
                </v-icon>
                Adicionar Feed
              </v-btn>
            </div>

            <v-data-table
              :headers="feedHeaders"
              :items="feeds"
              :loading="loadingFeeds"
              hide-default-footer
              dense
              class="elevation-1"
            >
              <template v-slot:item.source="{ item }">
                <v-chip
                  x-small
                  :color="sourceColor(item.source)"
                  dark
                >
                  {{ item.source }}
                </v-chip>
              </template>
              <template v-slot:item.is_active="{ item }">
                <v-icon
                  small
                  :color="item.is_active ? 'success' : 'grey'"
                >
                  {{ item.is_active ? icons.mdiCheckCircle : icons.mdiCircleOutline }}
                </v-icon>
              </template>
              <template v-slot:item.last_synced_at="{ item }">
                <span class="text-caption">{{ item.last_synced_at ? formatRelative(item.last_synced_at) : 'Nunca' }}</span>
                <div
                  v-if="item.last_error"
                  class="error--text text-caption"
                >
                  {{ item.last_error }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      :loading="item.loading_sync"
                      color="teal"
                      v-bind="attrs"
                      @click="triggerSyncFeed(item)"
                      v-on="on"
                    >
                      <v-icon small>
                        {{ icons.mdiSync }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Sincronizar agora</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      color="error"
                      v-bind="attrs"
                      @click="removeFeed(item)"
                      v-on="on"
                    >
                      <v-icon small>
                        {{ icons.mdiDeleteOutline }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Remover feed</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <span class="text-caption grey--text">Nenhum feed cadastrado</span>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeIcal"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG ADICIONAR FEED -->
    <v-dialog
      v-model="dialogAddFeed"
      max-width="500px"
    >
      <v-card>
        <div class="title_body">
          <span class="text_title">Adicionar Feed de Import</span>
          <span class="btn_close">
            <v-btn
              icon
              small
              @click="dialogAddFeed = false"
            ><v-icon dark>{{ icons.mdiClose }}</v-icon></v-btn>
          </span>
        </div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newFeed.label"
                  outlined
                  label="Nome do feed (ex: Booking Quarto 101)"
                  :error-messages="feedErrors.label"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newFeed.url"
                  outlined
                  label="URL do feed .ics"
                  hint="Booking: Extranet → Calendário → Exportar | Airbnb: Calendário → Exportar"
                  persistent-hint
                  :error-messages="feedErrors.url"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogAddFeed = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="loadingAddFeed"
            color="teal"
            dark
            @click="storeFeed"
          >
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MsgDelete
      v-model="dialogDelete"
      @delete-yes="deleteItemConfirm()"
    />
  </div>
</template>

<script>
import {
  mdiCalendarSync,
  mdiCheckCircle,
  mdiCircleOutline,
  mdiClose,
  mdiContentCopy,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiRefresh,
  mdiSync,
} from '@mdi/js'
import { mapActions } from 'vuex'
import MsgDelete from '@/components/MsgDelete.vue'
import NoDataTable from '@/components/NoDataTable.vue'

export default {
  components: { MsgDelete, NoDataTable },

  data: () => ({
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    dialogIcal: false,
    icalItem: {},
    feeds: [],
    loadingFeeds: false,
    loadingRegenToken: false,
    dialogAddFeed: false,
    loadingAddFeed: false,
    newFeed: { label: '', url: '' },
    feedErrors: { label: [], url: [] },
    headers: [
      { text: 'ID', align: 'start', value: 'id' },
      { text: 'Categoria', value: 'description' },
      {
        text: '', align: 'end', value: 'actions', sortable: false,
      },
    ],
    feedHeaders: [
      { text: 'Canal', value: 'source', width: 100 },
      { text: 'Label', value: 'label' },
      { text: 'Ativo', value: 'is_active', width: 60 },
      { text: 'Último Sync', value: 'last_synced_at' },
      {
        text: '', value: 'actions', sortable: false, width: 80,
      },
    ],
    categories: [],
    editedIndex: -1,
    editedItem: { description: '' },
    defaultItem: { description: '' },
    options: {},
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiCalendarSync,
      mdiContentCopy,
      mdiRefresh,
      mdiSync,
      mdiCheckCircle,
      mdiCircleOutline,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Categoria' : 'Editar Categoria'
    },
    icalExportUrl() {
      if (!this.icalItem.ical_token) return ''
      const base = process.env.VUE_APP_API_URL || window.location.origin

      return `${base}/api/ical/categoria/${this.icalItem.ical_token}/calendar.ics`
    },
  },

  watch: {
    dialog(val) { val || this.close() },
    dialogDelete(val) { val || this.closeDelete() },
    dialogIcal(val) { val || this.closeIcal() },
    dialogAddFeed(val) {
      if (!val) {
        this.newFeed = { label: '', url: '' }
        this.feedErrors = { label: [], url: [] }
      }
    },
    options: {
      handler() { this.initialize() },
    },
  },

  methods: {
    ...mapActions('room_category', ['getAll', 'store', 'update', 'delete']),
    ...mapActions('ical', {
      icalGetFeeds: 'getFeeds',
      icalStoreFeeds: 'storeFeeds',
      icalDeleteFeed: 'deleteFeed',
      icalSyncFeed: 'syncFeed',
      icalRegenerateToken: 'regenerateToken',
    }),

    initialize() {
      this.loadingTable = true
      const { page, itemsPerPage } = this.options
      this.getAll({ itemsPerPage: itemsPerPage || 10, page, search: this.search })
        .then(response => {
          this.categories = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => { this.loadingTable = false })
    },

    newItem() {
      this.editedItem = { ...this.defaultItem }
      this.editedIndex = -1
      this.dialog = true
    },

    editItem(item) {
      this.editedIndex = this.categories.indexOf(item)
      this.editedItem = { ...item }
      this.dialog = true
    },

    openIcal(item) {
      this.icalItem = { ...item }
      this.dialogIcal = true
      this.loadFeeds()
    },

    closeIcal() {
      this.dialogIcal = false
      this.feeds = []
      this.icalItem = {}
    },

    loadFeeds() {
      if (!this.icalItem.id) return
      this.loadingFeeds = true
      this.icalGetFeeds(this.icalItem.id)
        .then(r => { this.feeds = r.data })
        .finally(() => { this.loadingFeeds = false })
    },

    storeFeed() {
      this.feedErrors = { label: [], url: [] }
      if (!this.newFeed.label) {
        this.feedErrors.label = ['Obrigatório']

        return
      }
      if (!this.newFeed.url) {
        this.feedErrors.url = ['Obrigatório']

        return
      }

      this.loadingAddFeed = true
      this.icalStoreFeeds({ categoryId: this.icalItem.id, payload: this.newFeed })
        .then(r => {
          this.feeds.push(r.data)
          this.dialogAddFeed = false
          this.$toast.success('Feed adicionado!')
        })
        .catch(e => {
          const errors = e.response?.data?.errors || {}
          this.feedErrors.label = errors.label || []
          this.feedErrors.url = errors.url || []
        })
        .finally(() => { this.loadingAddFeed = false })
    },

    removeFeed(feed) {
      if (!confirm(`Remover feed "${feed.label}"?`)) return
      this.icalDeleteFeed({ categoryId: this.icalItem.id, feedId: feed.id })
        .then(() => {
          this.feeds = this.feeds.filter(f => f.id !== feed.id)
          this.$toast.success('Feed removido!')
        })
    },

    triggerSyncFeed(feed) {
      this.$set(feed, 'loading_sync', true)
      this.icalSyncFeed({ categoryId: this.icalItem.id, feedId: feed.id })
        .then(r => {
          this.$toast.success(`Sync: +${r.data.created} criadas, -${r.data.cancelled} canceladas`)
          this.loadFeeds()
        })
        .catch(() => { this.$toast.error('Erro ao sincronizar feed') })
        .finally(() => { this.$set(feed, 'loading_sync', false) })
    },

    copyExportUrl() {
      navigator.clipboard.writeText(this.icalExportUrl)
        .then(() => this.$toast.success('URL copiada!'))
    },

    confirmRegenToken() {
      if (!confirm('Regenerar token invalida a URL atual. Todos os canais precisarão ser atualizados. Confirmar?')) return
      this.loadingRegenToken = true
      this.icalRegenerateToken(this.icalItem.id)
        .then(r => {
          this.$set(this.icalItem, 'ical_token', r.data.ical_token)
          const cat = this.categories.find(c => c.id === this.icalItem.id)
          if (cat) this.$set(cat, 'ical_token', r.data.ical_token)
          this.$toast.success('Token regenerado!')
        })
        .finally(() => { this.loadingRegenToken = false })
    },

    deleteItem(item) {
      this.dialogDelete = true
      this.editedItem = item
    },

    deleteItemConfirm() {
      const index = this.categories.indexOf(this.editedItem)
      this.delete(this.editedItem)
        .then(() => {
          this.categories.splice(index, 1)
          this.closeDelete()
          this.$toast.success('Excluído com sucesso!')
        })
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    save() {
      this.loading = true
      if (this.editedIndex > -1) {
        const index = this.editedIndex
        this.update(this.editedItem)
          .then(response => {
            Object.assign(this.categories[index], response.data)
            this.close()
            this.$toast.success('Salvo com sucesso!')
          })
          .finally(() => { this.loading = false })
      } else {
        this.store(this.editedItem)
          .then(response => {
            this.categories.push(response.data)
            this.close()
            this.$toast.success('Salvo com sucesso!')
          })
          .finally(() => { this.loading = false })
      }
    },

    sourceColor(source) {
      const map = {
        airbnb: 'pink darken-2',
        booking: 'blue darken-2',
        expedia: 'yellow darken-3',
        vrbo: 'teal darken-1',
        temporada_livre: 'green darken-2',
        google: 'red darken-1',
      }

      return map[source] || 'grey'
    },

    formatRelative(dateStr) {
      if (!dateStr) return 'Nunca'
      const date = new Date(dateStr)
      const diff = Math.floor((Date.now() - date) / 1000)
      if (diff < 60) return `${diff}s atrás`
      if (diff < 3600) return `${Math.floor(diff / 60)}min atrás`
      if (diff < 86400) return `${Math.floor(diff / 3600)}h atrás`

      return `${Math.floor(diff / 86400)}d atrás`
    },
  },
}
</script>
